// eslint-disable-next-line no-unused-vars
import React from 'react';
import {
  IconOpenBanking, IconDataProtection, IconReceiptView, dlsBrightBlue, // eslint-disable-line no-unused-vars
} from '@americanexpress/dls-react';
import { routes } from '../../constants/paths';
import labels from '../../constants/labels';

export const userActions = {
  myActions: {
    id: 'my-actions',
    heading: labels.MY_ACTIONS,
    icon: <IconOpenBanking size="lg" theme={dlsBrightBlue} className="pad-1-t" />,
    primaryButtonLabel: labels.GET_STARTED,
    tertiaryButtonLabel: labels.LEARN_MORE,
    modalProp: {
      modalId: 'modal-my-actions',
      modalHeader: labels.MY_ACTIONS,
      modalBody: (
        <>
          <p>
            Use “My Actions” to review and respond to communications as well as to make required updates for file
            transfer management by following the link below.
          </p>
          <br />
          <ul>
            <li>User can respond to communications</li>
            <li>
              User can take action on requests (request content should describe request and enable user to satisfy
              request)
            </li>
          </ul>
          <br />
          <br />
        </>
      ),
      modalShowCase: {
        id: 'showMyActionModal',
        name: 'showMyActionModal',
        isChecked: true,
      },
    },
    componentPath: routes.myActions,
  },
  manageDigitalAssets: {
    id: 'manage-digital-assets',
    heading: labels.MANAGE_DIGITAL_ASSETS,
    icon: <IconDataProtection size="lg" theme={dlsBrightBlue} className="pad-1-t" />,
    primaryButtonLabel: labels.GET_STARTED,
    tertiaryButtonLabel: labels.LEARN_MORE,
    modalProp: {
      modalHeader: labels.MANAGE_DIGITAL_ASSETS,
      modalBody: (
        <>
          <p> Use “Manage Digital Assets” as the central location where you can update file transfer
            security information. Click to launch Manage Digital Assets:
          </p>
          <br />
          <ul>
            <li>Update your password</li>
          </ul>
          <br />
          <br />
        </>
      ),
      modalShowCase: {
        id: 'showMyDigitalAssetsModal',
        name: 'showMyDigitalAssetsModal',
        isChecked: true,
      },
    },
    componentPath: routes.manageDigitalAssets,
  },
  manageContacts: {
    id: 'manage-contact-information',
    heading: labels.CONTACTS,
    icon: <IconReceiptView size="lg" theme={dlsBrightBlue} className="pad-1-t" />,
    primaryButtonLabel: labels.GET_STARTED,
    tertiaryButtonLabel: labels.LEARN_MORE,
    modalProp: {
      modalHeader: labels.CONTACTS,
      modalBody: (
        <>
          <p>
            This is the central location where you establish valid contact information to make sure American Express and
            your Organization have established channels of communication for important notices and requests. Click
            to launch Contacts:
          </p>
          <br />
          <ul>
            <li>Update contact information</li>
          </ul>
          <br />
          <br />
        </>
      ),
    },
    componentPath: routes.manageContactInformation,
  },
};
